import { Injectable, OnInit } from '@angular/core';
import moment, { Moment } from 'moment';
import { AuditData } from '../../security-admin/models/field-audit';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor() { }

  today: AuditData[] = [];
  yesterday: AuditData[] = [];
  thisWeek: AuditData[] = [];
  lastWeek: AuditData[] = [];
  twoWeeksAgo: AuditData[] = [];
  threeWeeksAgo: AuditData[] = [];
  lastMonth: AuditData[] = [];
  older: AuditData[] = [];
  sortToggle = false;

  todaysDate: Moment;
  yesterdaysDate: Moment;
  startDateOfWeek: Moment;
  endDateOfWeek: Moment;
  startDateOfLastWeek: Moment;
  endDateOfLastWeek: Moment;
  startDateOfTwoWeekAgo: Moment;
  endDateOfTwoWeekAgo: Moment;
  startDateOfThreeWeekAgo: Moment;
  endDateOfThreeWeekAgo: Moment;
  startDateOfLastMonth: Moment;
  endDateOfLastMonth: Moment;
  

   historyData = [
    {
      title: 'Today',
      displayName: 'Today',
      value: this.today
    },
    {
      title: 'yesterday',
      displayName: 'Yesterday',
      value: this.yesterday
    },
    {
      title: 'thisWeek',
      displayName: 'This Week',
      value: this.thisWeek
    },
    {
      title: 'lastWeek',
      displayName: 'Last Week',
      value: this.lastWeek
    },
    {
      title: 'twoWeeksAgo',
      displayName: 'Two Weeks Ago',
      value: this.twoWeeksAgo
    },
    {
      title: 'threeWeeksAgo',
      displayName: 'Three Weeks Ago',
      value: this.threeWeeksAgo
    },
    {
      title: 'lastMonth',
      displayName: 'Last Month',
      value: this.lastMonth
    },
    {
      title: 'older',
      displayName: 'Older',
      value: this.older
    }
  ];

  public  reverseHistoryData() {
    this.historyData.reverse(); // Reverses accordian
    this.today.reverse();
    this.yesterday.reverse();
    this.thisWeek.reverse();
    this.lastWeek.reverse();
    this.twoWeeksAgo.reverse();
    this.threeWeeksAgo.reverse();
    this.lastMonth.reverse();
    this.older.reverse();
    this.sortToggle = !this.sortToggle; 
  }

  public groupTimeStamp(updateInfo: AuditData[]) {
      this.clearHistory();
      updateInfo.forEach(item => {
        const updatedDateTimeStamp = moment(moment(item.date).format('YYYY-MM-DDT00:00:00.000'));
        if (updatedDateTimeStamp.isSame(this.todaysDate)) {
          this.today.push(item);
        } else if (updatedDateTimeStamp.isSame(this.yesterdaysDate)) {
          this.yesterday.push(item);
        } else if (updatedDateTimeStamp >= this.startDateOfWeek && updatedDateTimeStamp <= this.endDateOfWeek) {
          this.thisWeek.push(item);
        } else if (updatedDateTimeStamp >= this.startDateOfLastWeek && updatedDateTimeStamp <= this.endDateOfLastWeek) {
          this.lastWeek.push(item);
        } else if (updatedDateTimeStamp >= this.startDateOfTwoWeekAgo && updatedDateTimeStamp <= this.endDateOfTwoWeekAgo) {
          this.twoWeeksAgo.push(item);
        } else if (updatedDateTimeStamp >= this.startDateOfThreeWeekAgo && updatedDateTimeStamp <= this.endDateOfThreeWeekAgo) {
          this.threeWeeksAgo.push(item);
        } else if (updatedDateTimeStamp >= this.startDateOfLastMonth && updatedDateTimeStamp <= this.endDateOfLastMonth) {
          this.lastMonth.push(item);
        } else {
          this.older.push(item);
        }
      });
    }

    public assignDateValues() {
        this.todaysDate = moment(moment().format('YYYY-MM-DDT00:00:00.000'));
        this.yesterdaysDate = moment(moment().subtract(1, 'days').format('YYYY-MM-DDT00:00:00.000'));
        this.startDateOfWeek = moment(moment().startOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.endDateOfWeek = moment(moment().endOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.startDateOfLastWeek = moment(moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.endDateOfLastWeek = moment(moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.startDateOfTwoWeekAgo = moment(moment().subtract(2, 'week').startOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.endDateOfTwoWeekAgo = moment(moment().subtract(2, 'week').endOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.startDateOfThreeWeekAgo = moment(moment().subtract(3, 'week').startOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.endDateOfThreeWeekAgo = moment(moment().subtract(3, 'week').endOf('week').format('YYYY-MM-DDT00:00:00.000'));
        this.startDateOfLastMonth = moment(moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDT00:00:00.000'));
        this.endDateOfLastMonth = moment(moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DDT00:00:00.000'));
      }

    public clearHistory(){
      this.today.length=0;
      this.yesterday.length=0;
      this.thisWeek.length=0;
      this.lastWeek.length=0;
      this.twoWeeksAgo.length=0;
      this.threeWeeksAgo.length=0;
      this.lastMonth.length=0;
      this.older.length=0;
    }
}
